import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import "primereact/resources/themes/lara-light-cyan/theme.css";
import 'primeicons/primeicons.css';

import Login from './Login/Login';
import Signup from './Signup/Signup';
import Landing from './Landing/Landing';
import Analysis from './Analysis/Analysis';
import ProtectedRoute from './utils/ProtectedRoute';
import MyScans from './myScans/myScans';
import Pricing from './Pricing/pricing';
function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/signup" element={<Signup />} />

          {/* Protected Routes */}
          <Route
            path="/landing"
            element={
              <ProtectedRoute>
                <Landing />
              </ProtectedRoute>
            }
          />
          <Route
            path="/analysis"
            element={
              <ProtectedRoute>
                <Analysis />
              </ProtectedRoute>
            }
          />
          <Route
  path="/my-scans"
  element={
    <ProtectedRoute>
      <MyScans />
    </ProtectedRoute>
  }
/>
<Route
  path="/pricing"
  element={
    <ProtectedRoute>
      <Pricing />
    </ProtectedRoute>
  }
/>

        </Routes>
      </div>
    </Router>
  );
}

export default App;
